import { createSlice } from "@reduxjs/toolkit";

import {
  addStatusPoints,
  deleteStatusPoints,
  //getStatusPoints,
  getStatusPointsByObjectiveId,
  updateStatusPoints,
} from "./thunk";

interface StatusPointsStateType {
  statusPoints: Array<any>;
  error?: string | object | null | undefined | unknown;
  success?: string | object | null | undefined | unknown;
}

export const initialState: StatusPointsStateType = {
  statusPoints: [],
  error: null,
  success: null,
};

const statusPointsSlice = createSlice({
  name: "statusPoints",
  initialState,
  reducers: {
    statusPointsError(state, action) {
      state.error = action.payload;
    },
    statusPointsSuccess(state, action) {
      state.success = action.payload;
    },
  },
  extraReducers: builder => {
    /*builder.addCase(getStatusPoints.fulfilled, (state: any, action: any) => {
      state.statusPoints = action.payload;
    });
    builder.addCase(getStatusPoints.rejected, (state, action) => {
      state.error = action.payload || null;
    });*/
    builder.addCase(addStatusPoints.fulfilled, (state: any, action: any) => {
      state.statusPoints.push(action.payload);
    });
    builder.addCase(addStatusPoints.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(updateStatusPoints.fulfilled, (state: any, action: any) => {
      state.statusPoints = state.statusPoints.map((statusPoints: any) =>
        statusPoints.id === action.payload.id
          ? { ...statusPoints, ...action.payload }
          : statusPoints
      );
    });
    builder.addCase(updateStatusPoints.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(deleteStatusPoints.fulfilled, (state: any, action: any) => {
      state.statusPoints = state.statusPoints.filter(
        (statusPoints: any) => statusPoints.id !== action.payload
      );
    });
    builder.addCase(deleteStatusPoints.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(
      getStatusPointsByObjectiveId.fulfilled,
      (state: any, action: any) => {
        state.statusPoints = action.payload;
      }
    );
    builder.addCase(getStatusPointsByObjectiveId.rejected, (state, action) => {
      state.error = action.payload || null;
    });
  },
});

export const { statusPointsError, statusPointsSuccess } =
  statusPointsSlice.actions;

export default statusPointsSlice.reducer;
